import "./AboutMe.module.css";
import PrimaryNavigation from "@/reusable_sections/Header";
import HeroIntroduction from "./sections/HeroIntroduction";
import MyStory from "./sections/MyStory";
import HowICanHelpYou from "./sections/HowICanHelpYou";
import PodcastSpotlight from "./sections/PodcastSpotlight";
import GetInTouch from "./sections/GetInTouch";
import BrandFooter from "@/reusable_sections/Footer";
export default function AboutMePage() {
  return <div>
      <PrimaryNavigation />
      <HeroIntroduction />
      <MyStory />
      <HowICanHelpYou />
      <PodcastSpotlight />
      <GetInTouch />
      <BrandFooter />
    </div>;
}